export var IDENTIFIER_BUTTON = 'button';
export var IDENTIFIER_BUTTON_OPTIONS = 'button-options';
export var TEXT_BUTTON = 'text-button';
